import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Urls } from "../../../utils/constant";
import { useApi } from "../apiCall/useApi";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";

import { getDoctorList } from "../../selectors/User_Master/user_Master.selector";
import {
  setDoctorComboList,
  setUserMasterList,
} from "../../reducers/User_Master/user_Master.reducer";

const COLUMN_LIST = [
  // { field: "customer_id", headerName: "ID", hide: true },
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },

  {
    field: "doctor_name",
    headerName: "Doctor Name",
    flex: 1,
  },
  {
    field: "email_id",
    headerName: "Email Id",
    flex: 1,
  },
  {
    field: "mobile_no",
    headerName: "Mobile No",
    flex: 1,
  },
  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "Active" },
  { id: 2, label: "In-Active" },
];

export default function useUserMaster() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [DoctorId, setDoctorId] = useState("");
  const [status, setStatus] = useState(1);
  const doctorList = useSelector(getDoctorList);

  const fetchUserMasterList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;
        const { data } = await apiPost({
          url: Urls.UserMasterGet(),
          data: {
            // id: "",
            doctor_id: "",
            page_size: row_count,
            current_page: current_page,
            status: StatusVal,
          },
        });
        // setting list to reducer
        dispatch(setUserMasterList(data));
        console.log(data, "data");
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, dispatch, status, apiPost]
  );

  const fetchDoctorComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getDoctorCombo(),
        data: {},
      });
      // setting list to reducer

      dispatch(setDoctorComboList(data.data));
    } catch (err) {
      console.log(err);
    }
  }, [apiPost, dispatch]);

  const findDoctorFromLabel = useCallback(
    (value) => {
      const selectedDoctorId = value
        ? doctorList.find((item) => item.label === value)?.id
        : null;
      setDoctorId(selectedDoctorId);
      return selectedDoctorId;
    },
    [doctorList]
  );

  // const handleNameChange = useCallback((e) => {
  //   setName(e.target.value);
  // }, []);

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    // Name,
    // handleNameChange,
    handleStatusChange,
    fetchUserMasterList,
    DoctorId,
    findDoctorFromLabel,
    fetchDoctorComboList,
  };
}
